import React from 'react';
import ServiceAdvisorCallReport from '../service_advisor/CallReport';

/**
 * Admin Call Report
 * Reuses the Service Advisor Call Report UI but routes complaint links to admin pages.
 */
const CallReport = () => {
  return (
    <ServiceAdvisorCallReport
      complaintDetailsPathPrefix="/complaints"
      showAIChat={true}
      scopeToCurrentUser={false}
      enableRecentCallsFilters={true}
    />
  );
};

export default CallReport;


